/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Common_DownloadInputs */

const en_pc_common_download = /** @type {(inputs: Pc_Common_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PdfCraft`)
};

const zh_pc_common_download = /** @type {(inputs: Pc_Common_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PdfCraft`)
};

/**
* | output |
* | --- |
* | "Download PdfCraft" |
*
* @param {Pc_Common_DownloadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_download = /** @type {((inputs?: Pc_Common_DownloadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_DownloadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_download(inputs)
	return zh_pc_common_download(inputs)
});
export { pc_common_download as "pc.common.download" }